import { render } from "./TagihanDetailPage.vue?vue&type=template&id=27bf2b9e&scoped=true"
import script from "./TagihanDetailPage.vue?vue&type=script&lang=js"
export * from "./TagihanDetailPage.vue?vue&type=script&lang=js"

import "./TagihanDetailPage.vue?vue&type=style&index=0&id=27bf2b9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bf2b9e"]])

export default __exports__